






















import Vue from "vue";
import Controls from "./Controls.vue";

interface IState {
  current: number;
  navigateInterval: number | undefined;
  autoSlideInterval: number | undefined;
  timer: number;
}
interface ISlide {
  image: string;
  link: string;
  name: string;
}

type Steps = () => ISlide[];

export default Vue.extend({
  name: "Slider",
  props: {
    steps: { type: Array as Steps, default: () => [] },
  },
  components: {
    Controls,
  },
  data: (): IState => ({
    current: 0,
    navigateInterval: undefined,
    autoSlideInterval: undefined,
    timer: 5000,
  }),
  computed: {
    pseudo(): ISlide[] {
      const steps: ISlide[] = this.steps;
      const items = [];
      while (items.length <= 5) {
        items.push(...steps);
      }
      return items as ISlide[];
    },
    slides(): number[] {
      const n = this.current;
      const max = this.pseudo.length - 1;
      return [
        n - 1 >= 0 ? n - 1 : max,
        n,
        n + 1 <= max ? n + 1 : n - max,
        n + 2 <= max ? n + 2 : n - max + 1,
        n + 3 <= max ? n + 3 : n - max + 2,
      ];
    },
  },
  mounted() {
    this.resetTimer();
  },
  methods: {
    stepComplete() {
      this.nav(1);
    },
    getClass(i: number): string {
      const slides: number[] = this.slides;
      if (i === slides[0]) return "slide--prev";
      if (i === slides[1]) return "slide--current";
      if (i === slides[2]) return "slide--next";
      if (i === slides[3]) return "slide--bottom";
      if (i === slides[4]) return "slide--past-bottom";
      return "";
    },
    nav(n: number): void {
      this.resetTimer();
      const length = this.pseudo.length;
      if (n < 0) {
        if (this.current === 0) {
          this.current = length - 1;
        } else {
          this.current--;
        }
      }
      if (n > 0) {
        if (this.current === length - 1) {
          this.current = 0;
        } else {
          this.current++;
        }
      }
    },
    resetTimer() {
      window.clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = window.setInterval(() => {
        this.nav(1);
      }, this.timer);
    },
    set(n: number): void {
      this.smoothNav(n);
      this.navigateInterval = window.setInterval(() => {
        this.smoothNav(n);
      }, 100);
      // this.current = n
    },
    stopTimer(): void {
      window.clearInterval(this.autoSlideInterval);
    },
    smoothNav(n: number): void {
      if (n > this.current) this.nav(1);
      else if (n < this.current) this.nav(-1);
      if (n === this.current) window.clearInterval(this.navigateInterval);
    },
  },
});
